import Cookies from "js-cookie"

/** Where authenticated users go when no `callbackUrl` is provided. The auth
 *  pages (signin, verify, callback) ALL default to this when the URL doesn't
 *  carry an explicit destination — change here, propagates everywhere. */
export const DEFAULT_POST_AUTH_DEST = "/create/ugc"

/** Synchronous best-effort auth check using cookies. Used in `beforeLoad`
 *  route guards where hooks aren't available. Auth.js sets `authjs.session-token`
 *  (or `__Secure-authjs.session-token` over HTTPS) on successful sign-in;
 *  `gc-logged-in` is a non-httpOnly hint we set ourselves for fast client gating. */
export const hasAuthCookie = (): boolean =>
  !!(Cookies.get("authjs.session-token") || Cookies.get("__Secure-authjs.session-token") || Cookies.get("gc-logged-in"))

/** Resolve a `?callbackUrl=...` value to a safe path. If the value is an
 *  absolute URL, only the pathname/search/hash are kept — the host is
 *  discarded as open-redirect protection (so `?callbackUrl=https://evil.com/x`
 *  becomes `/x`, not a redirect to evil.com). Relative paths pass through.
 *  Falsy / unparseable inputs return `fallback`. */
export const extractCallbackPath = (url: string | undefined, fallback = DEFAULT_POST_AUTH_DEST): string => {
  if (!url) return fallback
  if (!url.startsWith("http")) return url
  try {
    const parsed = new URL(url)
    return parsed.pathname + parsed.search + parsed.hash
  } catch {
    return fallback
  }
}
